import { httpClient } from '@/services/http/httpClient'

type GenerateSequenceParams = {
  id: string
}

type GenerateSequenceResponse = {
  sequence: string
}

export async function generateSequence({
  id,
}: GenerateSequenceParams): Promise<GenerateSequenceResponse> {
  const { data } = await httpClient.post<GenerateSequenceResponse>(
    `/ideas/admin/ideas/${id}/generate-sequence`,
  )
  return { sequence: data.sequence }
}
